import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b17508"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "HOME", -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.hoverHandler(true))),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => ($setup.hoverHandler(false))),
    onTouchstart: _cache[2] || (_cache[2] = ($event: any) => ($setup.touchHandler(true))),
    onTouchend: _cache[3] || (_cache[3] = ($event: any) => ($setup.touchHandler(false))),
    class: _normalizeClass(['return-to-home', $props.theme, $setup.status.hover ? 'on' : ''])
  }, _hoisted_2, 34))
}